import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, signal, ViewEncapsulation } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CurrentTransactionService } from '@orderna/admin-panel/src/app/services/shared/current-transaction/current-transaction.service';
import { LoadingService } from '@orderna/admin-panel/src/app/services/shared/loader/loading.service';
import {
  ButtonComponent,
  ButtonTextDirective,
} from '@orderna/admin-panel/src/app/shared/components/button/button.component';
import { InputTextAreaComponent } from '@orderna/admin-panel/src/app/shared/components/input/textarea/textarea.component';
import { ErrorListComponent } from '@orderna/admin-panel/src/app/shared/components/modal/error-list/error-list.component';
import { closePointOfSalesModal } from '../../utils/close-point-of-sales-modal';

@Component({
  selector: 'app-cancel-transaction-confirm',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatDialogModule,
    ButtonComponent,
    ButtonTextDirective,
    InputTextAreaComponent,
    ReactiveFormsModule,
    ErrorListComponent,
  ],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './cancel-transaction-confirm.component.html',
  styleUrl: '/src/app/shared/components/modal/modal.component.scss',
})
export class CancelTransactionConfirmComponent {
  Validators = Validators;

  #dialogRef = inject(MatDialogRef<CancelTransactionConfirmComponent>);
  #loadingService = inject(LoadingService);
  #formBuilder = inject(FormBuilder);
  #currentTransactionService = inject(CurrentTransactionService);

  errorMessages = signal<string[]>([]);
  loading = this.#loadingService.loading;
  formGroup = this.#formBuilder.group({
    reason: '',
  });

  async handleSubmit() {
    this.#dialogRef.disableClose = true;
    await this.submitTransaction();
  }

  closeDialog() {
    closePointOfSalesModal(this.#dialogRef);
  }

  async submitTransaction() {
    try {
      const reason = this.formGroup.value.reason!;
      await this.#currentTransactionService.cancel(reason);
      this.closeDialog();
    } catch (error) {
      this.onError(error as HttpErrorResponse);
    }
  }

  private onError(response: HttpErrorResponse) {
    console.error(response);
    const errors = response.error?.message;
    this.errorMessages.set(Array.isArray(errors) ? errors : [errors]);
  }
}
